import { render } from "./StaffSettings.vue?vue&type=template&id=8f4733ce"
import script from "./StaffSettings.vue?vue&type=script&lang=js"
export * from "./StaffSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__